/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

import logo from '../images/ondergrond-logo.svg'
import butchs from '../images/butchs-logo.png'

import { ParallaxProvider } from 'react-scroll-parallax';

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ParallaxProvider>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>
        <main>{children}</main>
        <footer>
          <div>
            <img src={logo} alt="Undergrond Logo" />
          </div>
          <div>
            <a href="https://butchs.net" target="_blank">
              <img
                style={{
                  maxWidth: "200px",
                }}
                src={butchs} alt="Butch's Logo" />
            </a>
          </div>
          <div>
            © {new Date().getFullYear()}, Ondergrond
					</div>
        </footer>
      </div>
    </ParallaxProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
